<template>
    <div>
        <dropdown-button
            icon-class="fa fa-ellipsis-v"
            button-class="is-small"
        >
            <div
                class="flex-con action-header is-grow"
            >
                <div
                    :class="{ 'active' : bulkActionOptions.SELECTED === value }"
                    @click="change($event, bulkActionOptions.SELECTED)"
                >
                    <div class="flex-con xs-pad-lr">
                        <div>
                            <div class="field has-addons">
                                <div class="control">
                                    <div
                                        class="button is-small"
                                        @click="toggleAll"
                                    >
                                        <span class="icon" >
                                            <i
                                                class="fa"
                                                :class="selected ? 'fa-check-square-o' : 'fa-square-o' "
                                            ></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            Using ({{selectedCount}}) Selected
                        </div>
                    </div>
                </div>
                <div
                    :class="{ 'active' : bulkActionOptions.ALL_ON_PAGE === value }"
                    @click="change($event, bulkActionOptions.ALL_ON_PAGE)"
                >
                    All On Page
                </div>
                <div
                    :class="{ 'active' : bulkActionOptions.ALL === value }"
                    @click="change($event, bulkActionOptions.ALL)"
                >
                    All <number :value="totalCount"></number> {{name}}
                </div>
            </div>
            <slot></slot>
        </dropdown-button>
    </div>
</template>

<script>
import BulkActionOptions from "../util/BulkActionOptions";

export default {
    name : "BulkActionsButton",
    props : {
        name : {
            type : String,
            required : true,
        },
        value : {
            type : String,
            required : true,
        },
        totalCount : {
            type : Number,
            required : true,
        },
        selectedCount : {
            type : Number,
            required : true,
        },
        fetching : {
            type : Boolean,
            required : true
        }
    },
    data () {
        return {
            selected : false
        }
    },
    computed : {
        bulkActionOptions () {
            return BulkActionOptions;
        },
        localValue : {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
                this.$emit('change', value);
            },
        }
    },
    methods : {
        change ($event, value) {
            $event.stopPropagation();
            this.localValue = value;
        },
        toggleAll ($event) {
            this.selected = !this.selected;
            $event.stopPropagation();
            this.$emit('toggle-select-all', this.selected);
        },
    },
    watch : {
        fetching : function () {
            //clear selected checkbox whenever data changes, which can be checked whenever fetching changes
            this.selected = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';
    .action-header {
        min-width:400px;
        text-align:center;

        & > div {
            color:$link;
            padding:5px 10px;
            border-bottom:1px solid $grey-lighter;
            cursor:pointer;
            line-height:22px;

            &:not(:last-child) {
                border-right:1px solid $grey-lighter;
            }

            &:hover,
            &.active {
                background-color:$white-ter;
                color:$black;
                border-bottom:1px solid $primary;
            }
        }

    }
    /deep/ .dropdown-content > a {
        padding:12px 10px !important;
    }
</style>
